import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDeals } from 'store/promoArea/promoAreaActions';
import { getLocationDealsQuery } from 'store/promoArea/promoAreaSelectors';

const PromoAreaDealsFetcher = () => {
  const dispatch = useDispatch();

  const query = useSelector(getLocationDealsQuery);

  useEffect(() => {
    dispatch(fetchDeals());
  }, [query, dispatch]);

  return null;
};

export default PromoAreaDealsFetcher;
